import Rebase from 're-base';

const base = Rebase.createClass({
	apiKey: "AIzaSyA2WirNpmkcfxlE0-kqU-JjfY9FoMP-8oo",
    authDomain: "catch-of-the-day-701f0.firebaseapp.com",
    databaseURL: "https://catch-of-the-day-701f0.firebaseio.com",
});

export default base;


/** WEBPACK FOOTER **
 ** ./src/base.js
 **/